import { Controller } from "@hotwired/stimulus"

// Opens and closes an inline information drawer. The controller wraps both the
// trigger and the panel, because they can sit apart in the DOM — e.g. the
// trigger next to a field label and the panel under the field box.
export default class extends Controller {
  static targets = ["trigger", "panel"]

  toggle() {
    this.panelTarget.hidden ? this.open() : this.close()
  }

  open() {
    this.panelTarget.hidden = false
    this.triggerTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.hidden = true
    this.triggerTarget.setAttribute("aria-expanded", "false")
  }

  // Close button inside the panel: hand focus back to the trigger so keyboard
  // users do not lose their place when the panel disappears.
  dismiss() {
    this.close()
    this.triggerTarget.focus()
  }
}
